import { ReactNode } from "react";
import { useNavigate } from "react-router";
import { twMerge } from "tailwind-merge";
import { useShallow } from "zustand/react/shallow";
import { getItemImage, Icon } from "../../../components";
import { Card, H6, IconType } from "@sellar-io/components";
import { DISCOVER_SEARCH } from "../../../constants/routes";
import { useDisplaySizeVariant } from "../../../hooks/useDisplaySizeVariant";
import { useDiscoveryV2SearchStore } from "./DiscoveryV2SearchStore";

const getIcon = (icon: IconType) => {
  if (["CAN", "KEG", "BADGE", "BOTTLE"].includes(icon)) {
    return <img className={"h-7.5 self-start"} src={getItemImage(icon)} />;
  }

  return <Icon size={1.3} icon={icon} />;
};

export const DiscoveryContainerCard = ({
  onClick,
  icon,
  name,
}: {
  onClick?: () => void;
  icon: Extract<IconType, "CAN" | "KEG" | "BOTTLE" | "BADGE">;
  name: string;
}) => {
  return (
    <Card
      className={twMerge(
        "bg-white",
        "flex cursor-pointer flex-col gap-3 border border-solid border-neutral-300 p-3 text-neutral-500 transition-colors hover:bg-neutral-50 sm:gap-6 sm:p-4",
      )}
      onClick={onClick}
    >
      {getIcon(icon)}
      <div className={"flex w-full items-center justify-between"}>
        <H6>{name}</H6>
        <div>
          <Icon icon={"CHEVRON_RIGHT"} className={"mr-auto"} size={1.1} />
        </div>
      </div>
    </Card>
  );
};

export const DiscoveryContainerCards = ({
  className,
}: {
  className?: string;
}) => {
  const { setContainerTypes } = useDiscoveryV2SearchStore(
    useShallow((state) => ({
      setContainerTypes: state.setContainerTypes,
    })),
  );
  const navigate = useNavigate();
  const { isDisplaySizeSatisfied, target } = useDisplaySizeVariant();

  const is2Xl = isDisplaySizeSatisfied("2xl");

  return (
    <div
      ref={target}
      className={twMerge(
        "grid grid-cols-2 gap-4",
        is2Xl && "grid-cols-4",
        className,
      )}
    >
      <DiscoveryContainerCard
        name={"Shop keg"}
        icon={"KEG"}
        onClick={() => {
          setContainerTypes(["keg"]);
          navigate(DISCOVER_SEARCH);
        }}
      />
      <DiscoveryContainerCard
        name={"Shop cask"}
        icon={"BADGE"}
        onClick={() => {
          setContainerTypes(["cask"]);
          navigate(DISCOVER_SEARCH);
        }}
      />
      <DiscoveryContainerCard
        name={"Shop can"}
        icon={"CAN"}
        onClick={() => {
          setContainerTypes(["can"]);
          navigate(DISCOVER_SEARCH);
        }}
      />
      <DiscoveryContainerCard
        name={"Shop bottle"}
        icon={"BOTTLE"}
        onClick={() => {
          setContainerTypes(["bottle"]);
          navigate(DISCOVER_SEARCH);
        }}
      />
    </div>
  );
};

export const DiscoverySuggestionTagContainer = ({
  children,
}: {
  children: ReactNode;
}) => {
  return <div className={"m-auto flex flex-wrap gap-2"}>{children}</div>;
};
